import { useState, useEffect, useRef } from 'react';
import ScratchCard from 'scratch-win-react';
import { lock, unlock } from 'tua-body-scroll-lock';

const ScratchCardGeneric = ({ coverImage, revealImage, headline }) => {
    const [width, setWidth] = useState(0);
    const [height, setHeight] = useState(0);
    const [brushSize, setBrushSize] = useState(20);
    const [isComplete, setIsComplete] = useState(false);
    const [imageLoaded, setImageLoaded] = useState(false);
    const [imageSize, setImageSize] = useState({ width: 0, height: 0 });

    const ScratchCardWrapperRef = useRef(null);
    const scratchCardRef = useRef(null);
    const hiddenBackImageRef = useRef(null);  // Direct reference to the <img> tag

    const frontImage = coverImage;
    const backImage = revealImage;

    function freezePage() {
        if (!isComplete) {
            lock();
        } else {
            unlock();
        }
    }

    function unfreezePage() {
        let onCompleteTimerScratchCard = setTimeout(() => {
            unlock();
        }, 400);
        return () => {
            clearTimeout(onCompleteTimerScratchCard);
        };
    }

    const handleImageLoad = () => {
        if (hiddenBackImageRef.current) {
            // Get the size of the image directly using getBoundingClientRect
            const rect = hiddenBackImageRef.current.getBoundingClientRect();

            // Ensure we're using the correct rendered height and width
            setImageSize({
                width: rect.width,
                height: rect.height,
            });
            setImageLoaded(true);  // Mark the image as loaded
        }
    };

    // Set the size of the Scratch Card after the image has loaded
    useEffect(() => {
        if (imageLoaded) {
            if (ScratchCardWrapperRef.current) {
                const wrapperWidth = ScratchCardWrapperRef.current.offsetWidth;

                // Set the width and brush size based on the wrapper width
                if (wrapperWidth < 716) {
                    setWidth(wrapperWidth);
                    setBrushSize(30);
                } else {
                    setWidth(624);
                    setBrushSize(80);
                }

                // Set the height based on the loaded back image size
                setHeight(imageSize.height);
            }
        }
    }, [imageLoaded, imageSize]);  // Re-run when imageLoaded or imageSize changes

    return (
        <>
            <div className="promo-fields-group">
                <div className="promo-fields">
                    <div className="promo-field">
                        <h3 className="prize-title-headline">{headline}</h3>
                        <div className="scratch-card-component">
                            <div className="scratch-card-wrap">
                                <>
                                    {/* Hidden wrapper to preload back image and get its size */}
                                    <div
                                        style={{
                                            position: 'absolute',  // Remove from normal document flow
                                            visibility: 'hidden', // Hide the image visually
                                            top: 0,               // Align at the top of the container (if needed)
                                            left: 0,              // Align at the left of the container (if needed)
                                            zIndex: -1,           // Ensure it's behind other content
                                        }}
                                    >
                                        <img
                                            ref={hiddenBackImageRef}  // Direct reference to the <img> element
                                            src={backImage}
                                            alt="Revealed"
                                            onLoad={handleImageLoad}  // Trigger the loading logic
                                        />
                                    </div>

                                    {/* Wait until the back image is loaded before rendering the ScratchCard */}
                                    {imageLoaded && (
                                        <div
                                            ref={ScratchCardWrapperRef}
                                            onTouchStart={freezePage}
                                            onTouchEnd={unfreezePage}
                                            onMouseDown={freezePage}
                                            onMouseUp={unfreezePage}
                                            className="scratch-card"
                                        >
                                            <ScratchCard
                                                ref={scratchCardRef}
                                                width={width}
                                                height={height}
                                                brushSize={brushSize}
                                                finishPercent={65}
                                                onComplete={() => {
                                                    setIsComplete(true);
                                                }}
                                                image={frontImage}
                                            >
                                                <div className="backImage">
                                                    {/* The back image is used now that it's loaded */}
                                                    <img
                                                        src={backImage}
                                                        alt="Revealed"
                                                    />
                                                </div>
                                            </ScratchCard>
                                        </div>
                                    )}
                                </>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <p>Image size: {imageSize.width}x{imageSize.height}</p> */}
        </>
    );
};

export default ScratchCardGeneric;
